module.exports = __webpack_public_path__ + "img/MKD.3d8d5998.gif";